import { Link } from 'react-router-dom';
import masterCard_icon from 'assets/MasterCard.svg';
import shield_icon from 'assets/shield.svg';
import visa_icon from 'assets/Visa.svg';
import { GUEST_ROUTES } from 'routes/routes';
import styled from "styled-components";

interface IFooterProps {
  openFeedbackModal: () => void;
  openEmailForm: () => void;
}

const Footer: React.FC<IFooterProps> = (props) => {
  const { openFeedbackModal, openEmailForm } = props;

  return (
    <FooterPlaceholder
      className={
        'mt-6 flex flex-col gap-y-8 px-4 pb-10 pt-4 text-white md:mb-4 md:flex-row md:items-center md:justify-between md:gap-y-0 md:px-0 md:pb-4'
      }
    >
      <div className={'order-2 md:order-1'}>{`© 2025 EroPlay.ai. SIA ChatMist.`}</div>

      <div
        className={
          'order-1 flex flex-col gap-6 sm:mb-4 md:order-2 md:mb-0 md:flex-row md:items-center md:gap-0'
        }
      >
        <span
          className={'cursor-pointer text-gray-500 hover:text-gray-50 md:mx-2'}
          onClick={openFeedbackModal}
        >
          Contact Us
        </span>

        <a

          href={GUEST_ROUTES.PRIVACY_POLICY()}
          className={'text-gray-500 hover:text-gray-50 md:mx-2'}
          target={'_blank'}
          rel="noreferrer"
        >
          Privacy Policy
        </a>

        <a
          href={GUEST_ROUTES.TERMS_OF_SERVICE()}
          className={'text-gray-500 hover:text-gray-50 md:mx-2'}
          target={'_blank'}
          rel="noreferrer"
        >
          Terms of Service
        </a>

        <a
          href={'https://dub.sh/eroplay-affiliate'}
          className={'text-gray-500 hover:text-gray-50 md:mx-2'}
          target={'_blank'}
          rel="noreferrer"
        >
          Become an Affiliate
        </a>

        <Link
          to="#"
          rel="noreferrer"
          target={'_blank'}
          className={'text-gray-500 hover:text-gray-50 md:mx-2'}
          onClick={openEmailForm}
        >
          Partner With Us
        </Link>
      </div>

      <div className={'order-3 flex flex-row items-center sm:mb-4 md:mb-0'}>
        <div className={'flex flex-row items-center text-white'}>
          <img src={masterCard_icon} className={'mr-2'} />
          <img src={visa_icon} className={'mr-2'} />
          <div
            style={{ width: '1px', height: '20px', background: 'white', opacity: 0.6 }}
            className={'mx-2'}
          ></div>
          <div className={'flex flex-row'}>
            <img src={shield_icon} className={'mx-2'} />
            <span>Safe and Secure</span>
          </div>
        </div>
        <div></div>
      </div>
    </FooterPlaceholder>
  );
};

export default Footer;

const FooterPlaceholder = styled.div`
  font-family: Nunito Sans;
  height: 110px;

  @media (max-width: 1200px) {
    height: auto;
    flex-direction: column;
    row-gap: 15px;
  }

  @media (max-width: 768px) {
    height: auto;
    /* padding-left: 10px;
    padding-right: 10px; */
  }
`;